import React from "react";

const SideLabelInput = (props) => {
  const {
    type,
    label,
    hideLabel,
    value,
    name,
    onChange,
    disabled,
    required,
    placeholder,
  } = props;

  return (
    <div className="flex">
      <div className="flex w-1/3 items-center">
        <label htmlFor={name} className={hideLabel ? "sr-only" : "text-xs"}>
          {label}
        </label>
      </div>
      <div className="w-full ml-5 text-xs">
        <input
          id={name}
          type={type}
          value={value ?? ""}
          name={name}
          onChange={onChange}
          disabled={disabled}
          required={required}
          placeholder={placeholder}
          className="w-full min-w-min h-9 px-1 border rounded-md"
        />
      </div>
    </div>
  );
};

export default SideLabelInput;
